/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/** @jsxImportSource @emotion/react */
import React, { useContext } from 'react';
import { ThemeContext } from '../../../config/theme';
import themedStyles from './CloseButton.css';

type Props = {
  onClick: () => void;
};

export default function CloseButton({ onClick }: Props) {
  const styling = themedStyles(useContext(ThemeContext));
  return (
    <div css={styling.closeButton} onClick={onClick}>
      <img src={process.env.REACT_APP_PUBLIC_URL + '/icons/cross.svg'} alt="close" />
    </div>
  );
}
